const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速启动',
    description: '冷启动仅需0.8秒，热启动瞬时响应，告别漫长的加载等待，让灵感不被中断。',
  },
  {
    icon: 'ri-database-2-line',
    title: '体积极小',
    description: '安装包仅28MB，不到主流同类产品的三分之一，节省宝贵的存储空间。',
  },
  {
    icon: 'ri-focus-3-line',
    title: '功能精准',
    description: '只保留经过数据验证的高频核心功能，去掉90%你永远不会用的模块。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台覆盖',
    description: 'Windows、macOS、iOS、Android 四大平台无缝同步，随时随地保持高效。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '端到端加密保护你的数据，通过ISO 27001认证，隐私安全有保障。',
  },
  {
    icon: 'ri-sun-line',
    title: '持续免费',
    description: '核心功能永久免费，无广告、无捆绑，我们通过增值服务实现可持续发展。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950">
            为什么选择<span className="text-primary-500">娜娜轻量版</span>？
          </h2>
          <p className="mt-4 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            我们坚信"少即是多"。娜娜轻量版不是功能的减法，而是体验的加法。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}